export default [
  {
    path: '/workUnlock',
    name: '/workUnlock',
    meta: {
      title: '解锁页面'
    },
    component: () => import(/* webpackChunkName: "example-workUnlock" */ '../views/workUnlock/workUnlock.vue')
  }
]